import { render, staticRenderFns } from "./GJHome.vue?vue&type=template&id=131d75b3&"
import script from "./GJHome.vue?vue&type=script&lang=js&"
export * from "./GJHome.vue?vue&type=script&lang=js&"
import style0 from "./GJHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports